module.exports = __webpack_public_path__ + "img/individual_employement.f9632c5f.svg";